
import React, {useState}                from 'react'

import AppointmentCalendarInternal      from './AppointmentCalendarInternal' 
import useBookingState, {B_ACTIONS}     from '../Booking/bookingReducer'

//import {OKCancel}                       from '../../lib/iprs-react-library/src/index.js';
import  {inPast}              from '../../lib/iprs-react-library/src/index.js';
import AppointmentCalendarEditOverLay   from './AppointmentCalendarEditOverLay';


const AppointmentCalendar = ({api, state, eventDispatch}) => {
    
    const { appType: {
        appointmentTypeID = 0,
        overlay
    }, booking } = state
    
    const [, bookingUpdater] = useBookingState(state, eventDispatch);
    const [error, setError]              = useState('');
    
    const handleSelectTime = (appTimeEvent) => {
        
        const { StartTime: start, FinishTime: end }    = appTimeEvent;
        
        if( !inPast( start ) ){ // can't select in the past
    
            // hold the slot before continuing
            const params = {
                AppointmentTypeID: appointmentTypeID,
                StartTime: start,
                FinishTime: end
            };

            const clinician = booking?.newBooking?.clinician?.partyID;
            if (clinician) {
                params["PartyID"] = clinician;
            }

            params.VisualCall = booking?.newBooking?.isVisual?? false;

            api.transact('HoldSlot', params)
            .then( r => r.apiResult )
            .then( r => { 
                setError('');
                bookingUpdater( B_ACTIONS.TIME_HELD_EVENT, r );
            } )
            .catch( err => setError(err.message) );
        }
    }

    const onEditCancel = e => eventDispatch({
        appType: {
            appointmentTypeID,
            overlay: null
        }
    });

    return (<>
        {overlay && <AppointmentCalendarEditOverLay state={state} onCancel={onEditCancel} eventDispatch={eventDispatch } />}
        <AppointmentCalendarInternal api={api} state={state} 
            setSelectedEvent={handleSelectTime}
            eventDispatch={eventDispatch} 
            /> 
            {error&&<p>{error}</p>}
    </>)
          
    
}

export default AppointmentCalendar